'use strict';

(function (angular) {
    angular.module('zp.home', []);
})(window.angular);